<template>
    <div class="frame-max uk-padding" :style="{left:(frameNum-1)*width+'px'}">
        <slot></slot>
        <div class="uk-text-center">
            <button @click="beginTest" :class="{displaynone: started}" class="uk-button uk-button-primary">Begin</button>
        </div>

        <div v-if="started" class="uk-animation-scale-down uk-margin-large-top uk-padding">
            <h1 class="uk-text-primary uk-text-center">Sample Questions</h1>
            <problem @updateAnswer="updateAnswer2($event)" v-for="(q, index) in test" :index="index" :answers="q.answers" :key="q.id">
                    {{ q.question }}
            </problem>
            <div>
                <span v-for="(ans, index) in useranswers" :key="index">{{ ans }}</span>
            </div>
            <div class="uk-text-center">
                <button class="uk-button uk-button-primary uk-margin-right" @click="backFrame">Back to Video</button>
                <button class="uk-button uk-button-primary uk-margin-left" @click="submitAnswers">I'm Ready!</button>
            </div>
            <div style="height:100px"></div>
        </div>
    </div>
</template>

<script>
import MultipleChoiceQ from './MultipleChoiceQ.vue';

export default {
    name: "Test",
    props: {
            testTitle: {
                default:"Default Test",
                type: String
            },
            Description: {
                default:"This is the default test description"
            },
            totalQuestions: {
                default: 1,
                type: Number
            },
            passBaseline: {
                default: 1,
                type: Number
            },
            isTimer: {
                default: false,
                type: Boolean
            },
            minutes: {
                default: 30,
                type: Number
            },
            testRequestUrl: {
                type: String,
                default: ""
            },
            test: {
                type: Array,
                default: function(){
                    return ['0']
                }
            },
            useranswers: {
                type: Array,
                default: function(){
                    return new Array(1)
                }
            },
            frameNum:{
                type: Number,
                default: 0
            },
            nextFrame:{
                type: Function
            },
            previousFrame: {
                type: Function
            }
        },
    data: function(){
        return {
            started: false,
            questionsAnswered: 0,
            currentQuestion: 0,
            finished: false,
            width: window.innerWidth
        }
    },
    methods: {
        beginTest(){
            if(this.isTimer === true){
                this.startTimer(this.minutes)
            }
            this.started = true;
            this.$emit('hideDescription')

        },
        startTimer(minutes){
            return minutes
        },
        updateAnswer2(event){
            // this.useranswers[event.index] = event.answer;
            this.$emit('updateanswerGlobal', event)
        },
        submitAnswers(){
            this.finished = true
            this.nextFrame(this.frameNum+1)
        },
        backFrame(){
            this.previousFrame(this.frameNum-1)
        }
    },
    components: {
        'problem':MultipleChoiceQ
    }
}
</script>

<style lang="less" scoped>

.displaynone {
  display: none;
}

</style>
